// src/config.js

const config = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:8080",
  REACT_APP_ENDUSER_API_BASE_URL: process.env.REACT_APP_ENDUSER_API_URL || "http://localhost:3200",
};

export default config;
